export enum BillingInterval {
  Monthly,
  Yearly,
  Once
}
